<!-- Button -->
<button
    mat-flat-button
    [matMenuTriggerFor]="userActions">
    <div class="flex flex-row justify-end items-center">
        <div class="mr-2 text-right">
            <div class="capitalize font-bold">{{ user.name }}</div>
            <!--<div class="mt-1 text-secondary text-xs capitalize">{{ user.activeRole.rolename }}</div>-->
        </div>
        <span class="relative">
        <img
            class="w-7 h-7 rounded-full"
            *ngIf="showAvatar && user.avatar"
            width="400" height="400"
            [ngSrc]="appSettingService.getFilePath(user.avatar)">
        <mat-icon
            *ngIf="!showAvatar || !user.avatar"
            [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    </span>
    </div>
</button>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Signed in as</span>
            <span class="mt-1.5 text-md font-medium">{{ user.email }})</span>
        </span>
    </button>

    <mat-divider class="my-2"></mat-divider>

    <button mat-menu-item [routerLink]="['/profile/settings']">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Profile</span>
    </button>

    <mat-divider class="my-2"></mat-divider>

    <button
        mat-menu-item
        (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>Sign out</span>
    </button>
</mat-menu>

<mat-menu
    class="user-status-menu"
    #roles="matMenu">
    <button *ngFor="let role of rolesList"
            mat-menu-item
            (click)="updateUserRole(role)">
        <span [ngClass]="{'text-primary': role.roleid == user.activeRole?.roleid}">{{ role.rolename }}</span>
    </button>
</mat-menu>
